'use client';

import { createContext } from 'react';
import { noop } from 'utils/noop';
import type { ToastContextType } from './ToastTypes';

const defaultContext: ToastContextType = {
  addToast: () => ``,
  removeToast: noop,
  updateToast: noop,
  defaultCloseLabel: ``,
};

export const ToastContext = createContext(defaultContext);
